/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompany
 */
export interface FreelancerCompany {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompany
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompany
     */
    name: string;
}

/**
 * Check if a given object implements the FreelancerCompany interface.
 */
export function instanceOfFreelancerCompany(value: object): value is FreelancerCompany {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FreelancerCompanyFromJSON(json: any): FreelancerCompany {
    return FreelancerCompanyFromJSONTyped(json, false);
}

export function FreelancerCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FreelancerCompanyToJSON(value?: FreelancerCompany | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

